import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { SsoComponent } from './components/sso/sso.component';
import { PortalComponent } from './components/portal/portal.component';
import { IndicatorComponent } from './components/indicator/indicator.component';
import { BlankPageComponent } from './components/blank-page/blank-page.component';
import { LoggedOutComponent } from './components/logged-out/logged-out.component';
import { RoutingErrorComponent } from './components/routing-error/routing-error.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { MenuExtensionComponent } from './components/menu-extension/menu-extension.component';
import { SystemDashboardComponent } from './components/system-dashboard/system-dashboard.component';
import { DifferentDomainComponent } from './components/different-domain/different-domain.component';
import { NdnqiPublicReportsComponent } from './components/ndnqipublic-report/ndnqipublic-report.component';
import { NdnqiFoundationComponent } from './components/ndnqi-foundation/ndnqi-foundation.component';
import { PerformanceReportsComponent } from './components/performance-reports/performance-reports.component';
import { LearningManagementComponent } from './components/learning-management/learning-management.component';
import { ValidationClientPortalComponent } from './components/validation-client-portal/validation-client-portal.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'if/ndnqiportal',
    pathMatch: 'full'
  },
  {
    path: 'if',
    redirectTo: 'if/ndnqiportal',
    pathMatch: 'full'
  },
  {
    path: 'ndnqiwrapper/if/ndnqiportal',
    redirectTo: 'if/ndnqiportal',
    pathMatch: 'full'
  },
  {
    path: 'ndnqiwrapper/if/NDNQIPortal',
    redirectTo: 'if/ndnqiportal',
    pathMatch: 'full'
  },
  {
    path: 'ndnqiwrapper/if/ndnqipublicreports',
    redirectTo: 'if/ndnqipublicreports',
    pathMatch: 'full'
  },
  {
    path: 'ndnqiwrapper/if/indicatorfactory',
    redirectTo: 'if/indicatorfactory',
    pathMatch: 'full'
  },
  {
    path: 'ndnqiwrapper/if/indicators',
    redirectTo: 'if/indicatorfactory',
    pathMatch: 'full'
  },
  {
    path: 'ndnqiwrapper/if/blankpage',
    redirectTo: 'if/blankpage',
    pathMatch: 'full'
  },
  {
    path: 'ndnqiwrapper/if/learning',
    redirectTo: 'if/learning',
    pathMatch: 'full'
  },
  {
    path: 'if/NDNQIPortal',
    component: PortalComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '**', component: PortalComponent }
    ]
  },
  {
    path: 'if/ndnqiportal',
    component: PortalComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '**', component: PortalComponent }
    ]
  },
  {
    path: 'if/validation',
    component: ValidationClientPortalComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '**', component: ValidationClientPortalComponent }
    ]
  },
  {
    path: 'if/performancereports',
    component: PerformanceReportsComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '**', component: PerformanceReportsComponent }
    ]
  },
  {
    path: 'if/learning',
    component: LearningManagementComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '**', component: LearningManagementComponent }
    ]
  },
  {
    path: 'if/sysdashboard',
    component: SystemDashboardComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '**', component: SystemDashboardComponent }
    ]
  },
  {
    path: 'if/ndnqipublicreports',
    component: NdnqiPublicReportsComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '**', component: NdnqiPublicReportsComponent }
    ]
  },
  {
    path: 'if/ndnqifoundation',
    component: NdnqiFoundationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '**', component: NdnqiFoundationComponent }
    ]
  },
  {
    path: 'if/indicatorfactory',
    component: IndicatorComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '**', component: IndicatorComponent }
    ]
  },
  {
    path: 'if/indicators',
    component: IndicatorComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '**', component: IndicatorComponent }
    ]
  },
  {
    path: 'if/editors',
    component: IndicatorComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '**', component: IndicatorComponent }
    ]
  },
  {
    path: 'if/NdnqiEventRegistration',
    component: IndicatorComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '**', component: IndicatorComponent }
    ]
  },
  {
    path: 'if/ndnqieventregistration',
    component: IndicatorComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '**', component: IndicatorComponent }
    ]
  },
  {
    path: 'if/differentdomain',
    component: DifferentDomainComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '**', component: DifferentDomainComponent }
    ]
  },
  {
    path: 'if/menuextension',
    component: MenuExtensionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'if/blankpage',
    component: BlankPageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'if/routingerror',
    component: RoutingErrorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    component: PortalComponent
  },
  {
    path: 'loggedout',
    component: LoggedOutComponent
  },
  {
    path: 'sso',
    component: SsoComponent
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];
